const animalLoaders = [
  () => import("../images/lottie_animations/lionLottieAnimation.json"),
  () => import("../images/lottie_animations/squirrelLottieAnimation.json"),
  () => import("../images/lottie_animations/snailLottieAnimation.json"),
  () => import("../images/lottie_animations/flyingCrocodileLottieAnimation.json"),
  () => import("../images/lottie_animations/elephantLottieAnimation.json"),
  () => import("../images/lottie_animations/toucanLottieAnimation.json"),
];

export async function loadRandomLoadingAnimation() {
  const loadAnimal = animalLoaders[Math.floor(Math.random() * animalLoaders.length)];
  const [runtime, animal] = await Promise.all([import("lottie-react"), loadAnimal()]);
  return { Lottie: runtime.default, animationData: animal.default };
}
